import { ConsumptionTable, CubeBasicFilters } from "../schemas/kpi.types";
import React, { useEffect, useState } from "react";
import { Col, Row, Spinner, Table } from "reactstrap";
import { kpiService } from "./kpi-service";
import { ReactComponent as IconSinestralidad } from "../../../assets/img/icon/dashboard/siniestralidad.svg";
import { formatCurrency, formatDate, formatPercent } from "../schemas/dashboard.utils";

export const KPITable: React.FC<{
    cubeFilters: CubeBasicFilters;
}> = ({ cubeFilters }) => {
    const [summaryPolicies, setSummaryPolicies] = useState<ConsumptionTable[]>([]);
    const [loading, setLoading] = useState(false);
    const { idClient, idQuotes, policy } = cubeFilters;

    const quotesExist = idQuotes?.length !== 1;

    useEffect(() => {
        const loadData = async () => {
            if (!idClient) return;
            try {
                setLoading(true);
                const data = await kpiService.fetchAccident(cubeFilters, quotesExist);
                setSummaryPolicies(data);
            } catch (error) {
                console.error("Error al cargar tabla:", error);
            } finally {
                setLoading(false);
            }
        };

        void loadData();
    }, [idClient, idQuotes, policy]);

    const premiumBilled = summaryPolicies.reduce((acc, row) => acc + (row["premiumsBilled"] || 0), 0);
    const premiumIncurred = summaryPolicies.reduce((acc, row) => acc + (row["premiumsIncurred"] || 0), 0);
    const accidentRate = premiumBilled > 0 ? (premiumIncurred / premiumBilled) * 100 : 0;

    return (
        <div className="siniestralidad-container">
            <div className="header-section">
                <div className="icon-wrapper">
                    <IconSinestralidad />
                </div>
                <h2 className="title-label">Siniestralidad</h2>
            </div>

            <Row>
                <Col>
                    {loading ? (
                        <div className="text-center py-4">
                            <Spinner color="primary" />
                        </div>
                    ) : (
                        <div className="table-responsive-wrapper">
                            <Table hover responsive className="align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th className={"text-center"}>Periodo</th>
                                        <th className="text-right">Primas facturadas</th>
                                        <th className="text-right">Reclamos incurridos</th>
                                        <th className="text-right">Siniestralidad %</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {summaryPolicies.length > 0 ? (
                                        summaryPolicies.map((row, index) => (
                                            <tr key={index + "-" + row["paymentDate"]}>
                                                {quotesExist ? (
                                                    <td className={"text-left"}>{row["paymentDate"]}</td>
                                                ) : (
                                                    <td className={"text-center"}>{formatDate(row["paymentDate"])}</td>
                                                )}
                                                <td className="text-right">{formatCurrency(row["premiumsBilled"])}</td>
                                                <td className="text-right">
                                                    {formatCurrency(row["premiumsIncurred"])}
                                                </td>
                                                <td className="text-right">{formatPercent(row["percentage"])}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={4} className="text-center text-muted">
                                                No hay datos disponibles para este paciente
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                {summaryPolicies.length > 0 && (
                                    <tfoot className="table-group-divider">
                                        <tr className="font-weight-bold">
                                            <td className={"text-center"}>Total</td>
                                            <td className="text-right">{formatCurrency(premiumBilled)}</td>
                                            <td className="text-right">{formatCurrency(premiumIncurred)}</td>
                                            <td className="text-right">{accidentRate.toFixed(2)} %</td>
                                        </tr>
                                    </tfoot>
                                )}
                            </Table>
                        </div>
                    )}
                </Col>
            </Row>
        </div>
    );
};
